import { type IPromo } from '../../../../../types/promos';

export function getImageUrl(promo: IPromo): string {
  if (promo.isFromBank) {
    return promo.bank?.secondSquareImageUrl || '';
  }

  return promo.authorLogoUrl || '';
}
